import cpdirect from '@@images/cpdirect/firm_logo.png';
import powrog from '@@images/powrog/firm_logo.png';
import flg from '@@images/flg/firm_logo.png';
import mmlf from '@@images/mmlf/firm_logo.png';
import klaw from '@@images/klaw/firm_logo.png';
import flaw from '@@images/flaw/firm_logo.png';
import cfs from '@@images/cfs/firm_logo.png';
import slaw from '@@images/slaw/firm_logo.png';
import mmdc from '@@images/mmdc/firm_logo.png';
import ksbr from '@@images/ksbr/firm_logo.png';
import vanstone from '@@images/vanstone/firm_logo.png';
import wieand from '@@images/wieand/firm_logo.png';
import wamsley from '@@images/wamsley/firm_logo.png';
import lacpd from '@@images/lacpd/firm_logo.png';
import gd from '@@images/gd/firm_logo.png';
import coleman from '@@images/coleman/firm_logo.png';
import { Brand } from '~utils/brand';

export const BrandLogoLight = () => {
	switch (Brand()) {
	case 'cpdirect':
		return cpdirect;
	case 'powrog':
		return powrog;
	case 'flg':
		return flg;
	case 'mmlf':
		return mmlf;
	case 'klaw':
		return klaw;
	case 'flaw':
		return flaw;
	case 'cfs':
		return cfs;
	case 'slaw':
		return slaw;
	case 'mmdc':
		return mmdc;
	case 'ksbr':
		return ksbr;
	case 'vanstone':
		return vanstone;
	case 'wieand':
		return wieand;
	case 'wamsley':
		return wamsley;
	case 'lacpd':
		return lacpd;
	case 'gd':
		return gd;
	case 'coleman':
		return coleman;
	default:
		return cpdirect;
	}
};
